import * as actionTypes from './actions/actionTypes';

const initialState = {
    isMobileView: false,
    width: 0,
    height: 0,
    themeId: 0,
    brandingText: 'MyAccount Manager', //default value
    config: {}
};

export const actionCreators = {
    setTheme: (themeId) => ({
        type: actionTypes.SET_THEME,
        themeId,
    }),
    setBrandingText: (brandingText) => ({ type: actionTypes.SET_BRANDING_TEXT, brandingText }),
    setWebConfig: (config) => ({ type: actionTypes.SET_WEB_CONFIG, config }),

    viewModeChanged: (isMobileView, size) => ({
        type: actionTypes.VIEW_MODE_CHANGED,
        isMobileView,
        size,
    }),
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === actionTypes.VIEW_MODE_CHANGED) {
        return {
            ...state,
            isMobileView: action.isMobileView,
            width: action.size ? action.size.width : 0,
            height: action.size ? action.size.height : 0,
        };
    }

    if (action.type === actionTypes.SET_THEME) {
        return {
            ...state,
            themeId: action.themeId,
        };
    }
    if (action.type === actionTypes.SET_BRANDING_TEXT) {
        return {
            ...state,
            brandingText: action.brandingText,
        };
    }
    else if (action.type === actionTypes.SET_WEB_CONFIG) {
        return {
            ...state,
            config: action.config,
        };
    }

    return state;
};
